export default __webpack_public_path__ + "static/media/yandex.ebed69a6.svg";